function Steps() {
    const steps = [
      "Ücretsiz Danışmanlık",
      "Uzman Doktorla Görüşme",
      "Kişiye Özel Tedavi Planı",
      "Sonuç ve Takip"
    ];
  
    return (
      <div className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center mb-5">Sürecimiz</h2>
          <div className="row">
            {steps.map((step, index) => (
              <div key={index} className="col-md-3 mb-4">
                <div className="card h-100 shadow-sm">
                  <div className="card-body text-center">
                    <h5 className="card-title">{step}</h5>
                    <p className="card-text">Detaylı açıklama buraya gelecek.</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
  
  export default Steps;